import { IkeyString } from '../../types/checkoutTypes';
export const BaseAPIUrl = '{BaseAPIUrl}';

export const CartId = '{CartId}';
export const EntryId = '{EntryId}';
export const CheckoutId = '{CheckoutId}';
export const FulfillmentId = '{FulfillmentId}';
export const PaymentId = '{PaymentId}';
export const OrderId = '{OrderId}';

export const Create_Checkout_API_Version = 'v1';
export const Update_Checkout_API_Version = 'v1';
export const Get_Checkout_API_Version = 'v1';
export const Place_Order_API_Version = 'v1';
export const Update_Payment_API_Version = 'v1';
export const Create_Payment_API_Version = 'v1';
export const Confirm_Delivery_Option_API_Version = 'v1';
export const Update_Delivery_Option_API_Version = 'v1';
export const Get_Pickup_Options_API_Version = 'v1';
export const Get_Checkout_Profile_API_Version = 'v1';
export const Get_Checkout_Tax_Documents_API_Version = 'v1';

export const checkoutCmsUid = 'checkout';
export const checkoutCmsVersion = 'v2';

export const LocalStorageKeys = {
  CHECKOUT_PROFILE: 'checkoutProfile',
  WAREHOUSE_ID: 'warehouseId',
};

export enum checkoutApiGenerics {
  CHECKOUT_INIT = 'checkoutInit',
  SHIPPING_DETAILS_LOADING = 'shippingDetailsLoading',
  PAYMENT_METHOD_LOADING = 'paymentMethodLoading',
  TAX_DETAIL_LOADING = 'taxDetailLoading',
}

export const initialLoading: IkeyString = {
  createCheckout: checkoutApiGenerics.CHECKOUT_INIT,
  getCheckout: checkoutApiGenerics.CHECKOUT_INIT,
  updateCheckout: checkoutApiGenerics.TAX_DETAIL_LOADING,
  getCheckoutByOrderId: checkoutApiGenerics.CHECKOUT_INIT,
  confirmDeliveryOption: checkoutApiGenerics.SHIPPING_DETAILS_LOADING,
  updateDeliveryOption: checkoutApiGenerics.SHIPPING_DETAILS_LOADING,
  createPaymentMethod: checkoutApiGenerics.PAYMENT_METHOD_LOADING,
  updatePaymentMethod: checkoutApiGenerics.PAYMENT_METHOD_LOADING,
};
